import React, { Component } from 'react'
import _get from 'lodash/get'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'
import Avatar from 'shared-web/src/components/Avatar'
import moment from 'moment'

export default class EventDetail extends Component {
  static defaultProps = {
    eventLabel: 'triggered event'
  }

  renderPageSeparator = () => {
    const eventBody = _get(this.props, 'event.body')
    const pageUrl = _get(this.props, 'event.body.attributes.url')
    if (pageUrl) {
      const pageTitle = eventBody.attributes.pageName || eventBody.attributes.title || pageUrl
      return (
        <span>
          <span key="page-sep"> - </span>
          <a key="page-link" href={pageUrl} target="_blank">{ pageTitle }</a>
        </span>
      )
    }
  }

  renderEventBody = () => (
    <span>{this.props.event.body.event}</span>
  )

  render() {
    const { children, eventLabel, event: { body, createdAt }, endUser, actionTaker } = this.props
    const timeCreatedLabel = moment(createdAt).format('LLL')
    const eventSource = (body && body.source) || _get(this.props, 'event.body.context.source') || 'Drift'
    const eventBody = _get(this.props, 'event.body.event')
    return (
      <div className="flex">
        <Avatar size="small" user={actionTaker || endUser}/>
        <div style={{ marginLeft: 12 }}>
          <div className="dsg-Body">
            <span className="dsg-medium-weight">{getDisplayName(actionTaker || endUser)}</span>&nbsp;
            <span className="color-navy-dark">{eventLabel}</span>&nbsp;
            {eventBody && this.renderEventBody()}
            {children}
            {this.renderPageSeparator()}
          </div>
          <div className="dsg-Regular color-navy-dark">
            {timeCreatedLabel} via {eventSource}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/EventDetail/index.js